import { Inject, Injectable } from "@angular/core";
import IPushNotificationPort from "src/app/domain/ports/i-push-notification";

@Injectable()
export class PushNotificationUseCase{
  constructor(
    @Inject('IPushNotificationPort') private pushNotificationAdapter: IPushNotificationPort
  ){}

  requestPermission(){
    this.pushNotificationAdapter.requestPermission()
  }

}
